
import React, { useContext, useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import { IoMdClose } from "react-icons/io";
import { BsSearch } from "react-icons/bs";
import {useNavigate } from 'react-router-dom';
import "./style.css";
import Warning from '../../../../components/Warning';
import { LoginContext } from '../../../../contexts/login_context';
import { dismissToast, showError, showWait } from '../../../../services/toast';
import { useSelector } from '../../../../native-state.dev';
import DataTable, { TableColumn } from 'react-data-table-component';
import BootyPagination from '../../../../components/Pagination';
import NewWarning from '../../../../components/newWarning';
import ExportDetail from '../../../../components/ExportDetail';
import { consultarGpcNcm } from '../../../../services/consultaGPCNCM';
import TableNCMGPC from '../../../../components/tableNCM&GPC';
import { useSearchPagination } from '../../../../contexts/Ncm&Gpc_context';
import { buildVerifyCompanyNcmRows } from '../../../../services/exportFileFrontEndVerifyCompanyNcm';
import { exportFileTest } from '../../../../services/exportFileFrontEndGTIN';
import { set } from 'date-fns';



const SearchOneNCM = () => {
  const [modalObje, setState] = useSelector((s: { searchDone: any; })=>s.searchDone);
  const [view, setView] = useState({ error: false, content: false });
  const [errorTitle, setErrorTitle] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const { jwt } = useContext(LoginContext);
  const [code, setCode] = useState("");
  const [valueCNPJ, setValueCNPJ] = useState("");
  const [country, setCountry] = useState<any>(null);
  const [ShowIcon, setShowIcon] = useState(true);
  const [ShowImage, setShowImage] = useState('');
  const [ShowText, setShowText] = useState('');
  const [isFocused, setFocused] = useState(false);
  const [searchResultText, setSearchResultText] = useState('');
  const myRef: any = useRef();

  const [details, setDetails] = useState<any | null>(null);
  const iconMinus = '/icon-minus.svg';
  const iconPlus = '/icons-plus.svg';
  const [dataPrepared, setdataPrepared] = useState<any>();

  const [pages, setPages] = useState<number[]>([]);
  const [selectedPages, setSelectedPages] = useState<number[]>([]);
  const { Datapagina, setStepMaganer, stepMaganer, setSelectRows, setDataAll, setDatapagina } = useSearchPagination();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenBack, setIsModalOpenBack] = useState(false);
  const [ipsOpenModalConfirm, setIpsOpenModalConfirm] = useState(false);
  const [lastFilters, setLastFilters] = useState<any | null>(null);
  const [limitConfirmation, setLimitConfirmation] = useState<any | null>(null);

  const navigate = useNavigate();
  
  type Row = { GTIN?: string | number | null };
  const LS_KEY = 'searchMany:pendingGtins';

  const [selectedGtins, setSelectedGtins] = useState<string[]>([]);
  const handleSelectedRowsChange = (state: { selectedRows: Row[] }) => {
    const gtins: string[] = Array.from(
      new Set(
        (state.selectedRows ?? [])
          .map(r => (r.GTIN ?? '').toString())
          .map(s => s.replace(/\D+/g, ''))
          .filter(Boolean)
      )
    ).slice(0, 100);

    localStorage.setItem(LS_KEY, JSON.stringify(gtins));

    setSelectedGtins(gtins);
    setSelectRows?.(gtins);
  };

  const handleContinuar = () => {
    if (!Datapagina || Datapagina.length === 0) {
      showError("Não há dados para exportar.");
      return;
    }

    const rows = buildVerifyCompanyNcmRows(Datapagina);
    exportFileTest(rows, 'xls'); 

    if (!localStorage.getItem(LS_KEY)) {
      localStorage.setItem(LS_KEY, JSON.stringify(selectedGtins));
    }
    navigate('/search-many');
  };


    const handleContinuarBackList = () => {
      const rows = buildVerifyCompanyNcmRows(Datapagina);
      exportFileTest(rows, 'xls'); 

      if (!localStorage.getItem(LS_KEY)) {
        localStorage.setItem(LS_KEY, JSON.stringify(selectedGtins));
      }
      searchCode('Atualizando lista de vizualizados');
      setStepMaganer('list');
      setIsModalOpenBack(false);
  };


  useEffect(() => {
    try { Modal.setAppElement('#root'); } catch {}
  }, []);

  const openChangeScreenModal = () => setIsModalOpen(true);
  const openChangeScreenModalBack = () => setIsModalOpenBack(true);
  const closeChangeScreenModal = () => setIsModalOpen(false);
  const closeChangeScreenModalBack = () => setIsModalOpenBack(false);
  const closeChangeScreenModalConfirm = () => setIpsOpenModalConfirm(false);

  const handleConfirmChangeScreen = () => {
    setStepMaganer('table');
    setIsModalOpen(false);
  };

  const handleConsultarDadosProduto = () => {
    if (!selectedGtins || selectedGtins.length === 0) {
      showError('Selecione pelo menos um GTIN na tabela para consultar os dados do produto.');
      return;
    }
    openChangeScreenModal();
  };

  const ValorDataPagina = Datapagina.length;
  const textData = `Sua consulta retornou ${ValorDataPagina} GTINs. Caso queira consultar os dados de produtos, por favor, selecione os GTINs e clique no botão "Consultar os dados do produto"`;
;

  const togglePage = (page: number) => {
    setSelectedPages(prev => (prev[0] === page ? [] : [page]));
  };

  const customStyles = {
    rows: {
      style: {
        display:'flex',
        justifyContent: 'space-around',
        minHeight: '50px',
        fontFamily: "'-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'",
        fontSize: "0.94rem",
        color: "#002c6c",
        '&:nth-of-type(odd)': { backgroundColor: '#ffffff' },
        '&:nth-of-type(even)': { backgroundColor: '#e4e8ea' }
      },
    },
    headRow: {
      style:{ display: 'flex', alignItems:'center', justifyContent: 'space-around', borderTop:'1px solid #ccc' }
    },
    TableCell:{ style:{ color:'red' }},
    headCells: {
      style: {
        paddingLeft: '6px',
        paddingRight: '6px',
        fontFamily: "'-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'",
        fontSize: "0.94rem",
        color: "#002c6c",
      },
    },
    cells: {
      style: {
        paddingLeft: '6px',
        paddingRight: '6px',
        fontWeight: "500 !important",
        display: 'flex',
        justifyContent: '',
      },
    },
    pagination: {
      style: {
        color: "#002c6c",
        fontFamily: "'-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'",
        fontSize: '0.94rem',
        minHeight: '56px',
      },
    },
  };

  const formatTipoGtin = (tipo: any): string => {
    if (!tipo) return '---';

    const raw = String(tipo)
      .replace(/^"+|"+$/g, '') 
      .trim();

    return raw.replace('_', '-');
};


  const columns: TableColumn<any>[] = [
    {
      name: 'GTIN',
      selector: (row: { GTIN: any }) => row.GTIN || '---',
      sortable: true,
      wrap: true,
      center: true,
      width: '240px',
    },
    {
    name: 'Descrição do Produto',
    selector: (row: { DESCRICAO: any }) =>
      (row.DESCRICAO || '---').toString().trim(), 
    maxWidth: '240px',
    wrap: false,
    sortable: true,
  },
    {
      name: 'Tipo de GTIN',
      selector: (row: { TIPO_GTIN: any }) => formatTipoGtin(row.TIPO_GTIN),
      maxWidth: '150px',
      wrap: false,
      sortable: true,
    },
  ];

  useEffect(() => {
    setStepMaganer("none");
  }, []);

  const onFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    send();
  };

  const handleBackTable = () => {
    const rows = buildVerifyCompanyNcmRows(Datapagina);
    exportFileTest(rows, 'xls'); 

    if (!localStorage.getItem(LS_KEY)) {
      localStorage.setItem(LS_KEY, JSON.stringify(selectedGtins));
    }
    searchCode('Atualizando lista de vizualizados');
    setStepMaganer('list');
  }

  async function send() {
    searchCode();
  }

  const handleIconAndText = () => {
    if(ShowIcon === true){
      setShowText ('Ocultar Filtrar por CNPJ');
      setShowImage(iconMinus);
      setShowIcon(false);
    } else {
      setShowText ('Filtrar por CNPJ');
      setShowImage(iconPlus);
      setShowIcon(true);
    }
  };

  const validate = () => {
    let message: string = '';
    let titleMessage: string = '';
    let error: boolean  = false;
    setView({ error: false, content: false });

    const select = document.getElementById('selectIdCountry') as HTMLSelectElement;
    const input = document.getElementById('empresaId') as HTMLInputElement;
    const currentValueSelect = select?.value;
    const currentInputValue = input?.value?.trim();

    if (!currentInputValue) {
      error = true;
      titleMessage = 'Nenhum código foi digitado no campo de busca';
      message = 'Por favor, informe ao menos um código para consulta';
    }
    if (currentInputValue && currentInputValue.length < 8) {
      error = true;
      titleMessage = 'O número informado é curto';
      message = 'Por favor, informe um código com 8 dígitos';
    }
    if (!currentValueSelect) {
      error = true;
      titleMessage = 'Nenhuma chave foi selecionada';
      message = 'Por favor, selecione uma das opções para a busca';
    }
    return { message, titleMessage, error };
  };

  const searchCode = async (textConsult?:string) => {
    setStepMaganer('none');
    const valid = validate();
    if (!valid.error) {
      textConsult = 'Aguarde, enquanto realizamos sua pesquisa'
      const toastId = showWait(textConsult);
      setIsDisabled(true);

      const hasCnpj = Boolean(valueCNPJ && valueCNPJ.trim());
      const sliceCnpj = valueCNPJ.replace(/\D/g, '').slice(0, 14);
      const filtros: any = {
        [country!.toLowerCase()]: code,
        ...(hasCnpj ? { cnpj: sliceCnpj } : {}),
      };

      try {
        const result = await consultarGpcNcm(jwt, filtros);

        dismissToast(toastId);
        setIsDisabled(false);

        setLastFilters(filtros);

        const limitInfo = result?.result?.requerConfirmacao ? result.result : result;

        if (limitInfo?.requerConfirmacao) {
          const qtdDisponivel = Number(limitInfo.qtdDisponivel ?? 0);

          if (qtdDisponivel <= 0) {
            showError(
              'Sua busca excede o número disponível de consulta. Por favor, verificar a quantidade de consultas restantes na área de administrador.'
            );
            return;
          }

          setLimitConfirmation(limitInfo);
          setIpsOpenModalConfirm(true);
          return;
}

        if (result.success && result.result) {
          setView({ error: false, content: true });
          setdataPrepared(result.result?.data);

          setTimeout(() => {
            if (myRef && myRef.current) {
              myRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          }, 100);

          setDataAll?.(result.result.VISITED_PAGES);
          setStepMaganer('list');

          const hasCnpj = Boolean(valueCNPJ && valueCNPJ.trim());
          const dataArr = result.result?.data;
          const max = getMaxPages(dataArr, hasCnpj);

          if (Number.isFinite(max) && max > 0) {
            const list = Array.from({ length: max }, (_, i) => i + 1);
            setPages(list);
            setSelectedPages([]);
          } else {
            setPages([]);
            setSelectedPages([]);
          }

        } else {
          setView({ error: true, content: false });
          setErrorTitle('Código não encontrado');
          setErrorMessage("Por favor, verifique se há erros de digitação e tente novamente.");
        }
      } catch (err: any) {
        dismissToast(toastId);
        setIsDisabled(false);

        const erroApi = err?.response?.data?.erro;

        if (erroApi?.includes("Expecting value")) {

          setView({ error: true, content: false });
          setErrorTitle("Código não encontrado");
          setErrorMessage("Por favor, verifique se há erros de digitação e tente novamente.");
          return;
        }
        if (err?.response?.status === 400) {
          setView({ error: true, content: false });
          setErrorTitle("Código não encontrado");
          setErrorMessage("Por favor, verifique se há erros de digitação e tente novamente.");
          return;
        }

        showError("Erro inesperado na consulta");
      }
    } else {
      setView({ error: true, content: false });
      setErrorTitle(valid.titleMessage);
      setErrorMessage(valid.message);
    }
  };

  const handleConfirmarConsulta = async () => {
    if (!lastFilters) {
      setIpsOpenModalConfirm(false);
      return;
    }

    const filtrosConfirmados = {
      ...lastFilters,
      confirmar: true,
    };

    setIpsOpenModalConfirm(false);
    await searchCodeComFiltros(filtrosConfirmados);
};

  const searchCodeComFiltros = async (filtros: any) => {

  const toastId = showWait('Reprocessando consulta...');
  setIsDisabled(true);

  try {
    const result = await consultarGpcNcm(jwt, filtros);

    dismissToast(toastId);
    setIsDisabled(false);

    if (!result?.success || !result.result) {
      setView({ error: true, content: false });
      setErrorTitle('Erro na consulta');
      setErrorMessage('Não foi possível reprocessar a consulta.');
      return;
    }

    const raw = result.result;

    let produtos: any[] = [];
    let mensagemLimite: string | undefined;

    if (Array.isArray(raw)) {
      produtos = (raw.find((x: any) => Array.isArray(x)) as any[]) || [];

      const limitObj = raw.find(
        (x: any) => x && typeof x === 'object' && 'mensagemLimite' in x
      ) as { mensagemLimite?: string } | undefined;

      mensagemLimite = limitObj?.mensagemLimite;
    } else if (raw && Array.isArray(raw.data)) {
      produtos = raw.data;
    }

    if (!produtos || produtos.length === 0) {
      setDatapagina([]);
      setStepMaganer('list');

      setView({ error: true, content: false });
      setErrorTitle('Nenhum resultado encontrado');
      setErrorMessage(
        mensagemLimite || 'Não há registros para exibir nesta consulta.'
      );
      return;
    }

    setDatapagina(produtos);
    setStepMaganer('table');      

    setdataPrepared(raw);

    setTimeout(() => {
      if (myRef && myRef.current) {
        myRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }, 100);

    if ((raw as any)?.VISITED_PAGES) {
      setDataAll?.((raw as any).VISITED_PAGES);
    }

    if (mensagemLimite) {
      showError(mensagemLimite);
    }
  } catch (err) {
    dismissToast(toastId);
    setIsDisabled(false);
    showError('Erro inesperado na consulta');
  }
};



  const handleRequireConfirmation = ({ filtros, raw }: { filtros: any; raw: any }) => {
    const qtdDisponivel = Number(raw?.qtdDisponivel ?? 0);

    if (qtdDisponivel <= 0) {
      showError(
        'Sua busca excede o número disponível de consulta. Por favor, verificar a quantidade de consultas restantes na área de administrador.'
      );
      return;
    }

    setLastFilters(filtros);
    setLimitConfirmation(raw);
    setIpsOpenModalConfirm(true);
  };


  const handleCnpjChange = (e:any) => {
    const raw = e.target.value.replace(/\D/g, '');

    const masked = raw
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .slice(0, 18); 

    setValueCNPJ(masked);
  };


  function getMaxPages(data: any, hasCnpj: boolean): number {
  if (!Array.isArray(data)) return 0;

  if (hasCnpj) {
    const nodeObj = data.find(
      (x: any) =>
        x &&
        typeof x === "object" &&
        "MAX_PAGINA_CNPJ" in x
    );
    if (nodeObj) {
      return Number(nodeObj.MAX_PAGINA_CNPJ) || 0;
    }

    const nodeStr = data.find(
      (x: any) =>
        typeof x === "string" &&
        x.startsWith("MAX_PAGINA_CNPJ:")
    );

    if (nodeStr) {
      const [, valor] = (nodeStr as string).split(":");
      return Number(valor) || 0;
    }

    return 0;
  }

  const node = data.find(
    (x: any) =>
      x &&
      typeof x === "object" &&
      (x.MAX_PAGINA_GPC != null || x.MAX_PAGINA_NCM != null)
  );

  return Number(node?.MAX_PAGINA_GPC ?? node?.MAX_PAGINA_NCM) || 0;
}



  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    if (selectedValue) {
      setCountry(selectedValue);
    }
  };

  return (
    <>
      <div className='bg-color-ui-1'>
        <div className='container'>
          <div className='row customWidth bg-color-white  px-4 rounded-lg'>
            <div className='col-12 col-md-12 mb-5'>
              <div className='customSpanOptions'>
                <label onClick={handleIconAndText} className="form-check-label-custom">
                  <span>
                    <img style={{marginBottom:'2px'}} width='20px' height='20px' src={ShowImage || iconPlus} />
                    {ShowText || 'Filtrar por CNPJ'}
                  </span>
                </label>
              </div>
              <form onSubmit={onFormSubmit}>
                <div id={`${ShowIcon === false ? 'customDisplay' : 'custom-responsi'}`}>
                  <div className=" custom-select1 form-group mb-0">
                    <select
                      style={{height:'46px', padding:'0px', paddingLeft:'10px'}}
                      className="form-control"
                      id='selectIdCountry'
                      onChange={handleSelectChange}
                      defaultValue={''}
                    >
                      <option disabled value={''}>Selecione uma opção</option>
                      <option value="GPC">GPC (Classificação Global de Produtos)</option>
                      <option value="NCM">NCM (Nomenclatura Comum do Mercosul)</option>
                    </select>

                    {ShowIcon === false &&
                      <div style={{marginTop:'10px'}}>
                        <div className='custom-border5'  style={{height:'44px',  marginBottom:'10px'}}>
                          <label className='container_my_input_custom custom-height-container-input'>
                            <BsSearch />
                            <input
                              id='inputId'
                              onFocus={() => setFocused(true)}
                              onBlur={() => setFocused(false)}
                              placeholder="CNPJ (opcional)"
                              onChange={handleCnpjChange}
                              value={valueCNPJ}
                              maxLength={18}
                              className="especial_input"
                              style={{outline:'none', border: 'none',fontSize:'100%'}}
                              disabled={isDisabled}
                            />
                          </label>
                        </div>
                      </div>
                    }
                  </div>

                  <div className='custom-container-input' style={{display:'flex', justifyContent:'flex-end'}}>
                    <div className='custom-border5'>
                      <label className='container_my_input_custom custom-height-container-input'>
                        <BsSearch />
                        <input
                          id='empresaId'
                          inputMode="numeric"      
                          pattern="\d*"    
                          onFocus={() => setFocused(true)}
                          onBlur={() => setFocused(false)}
                          placeholder="Digite o código"
                          onChange={(e) => {
                              const onlyDigits = e.target.value.replace(/\D/g, "").slice(0, 8);
                              setCode(onlyDigits);
                            }}
                          value={code}
                          className="especial_input"
                          style={{outline:'none', border: 'none', fontSize:'100%'}}
                          disabled={isDisabled}
                          maxLength={8}
                        />
                      </label>
                    </div>
                    <div>
                      <button
                        type="submit"
                        className="custom-button-especial"
                        disabled={isDisabled}
                        onClick={()=>setDetails(null)}
                      >
                        Buscar
                      </button>
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>

        {view.error && (
          <div className="row">
            <Warning
              type="error"
              showpick={false}
              title={errorTitle}
              text={errorMessage}
            />
          </div>
        )}
      </div>

      {stepMaganer === "list" && pages.length > 0 && (
        <div className="col-12 mt-4" style={{ maxWidth: '1100px', padding: 0 }}>
          <div className="bg-color-ui-1 pb-5 wp-home">
            <div className="container bg-color-white py-5 px-4 rounded-lg" style={{width:'102%'}} ref={myRef}>
              <TableNCMGPC
                pages={pages}
                code={code}
                country={country}
                valueCNPJ={valueCNPJ}
                selected={selectedPages}
                onToggle={togglePage}
                searchResultText={searchResultText}
                onRequireConfirmation={handleRequireConfirmation} 
              />
            </div>
          </div>
        </div>
      )}

      {stepMaganer === "table" && Datapagina && Datapagina.length > 0 && ( 
        <div className="col-12 mt-4" style={{ maxWidth: '1100px', padding: 0 }}>
          <div className="bg-color-ui-1 wp-home">
            {Datapagina && stepMaganer === "table" && (
              <div className="bg-color-ui-1 pb-5 wp-home mt-4">
                <div className="container">
                  <div
                    style={{ paddingBottom: 10, fontSize: '14pt', color: '#0c9ae3', cursor: 'pointer' }}
                    onClick={openChangeScreenModalBack}
                  >
                    &lt; Voltar para o resultado de busca
                  </div>
                </div>
              </div>
            )}

            <div className="bg-color-white px-4 rounded-lg" style={{ width: '100%' }}>
              <div className="row">
                <NewWarning
                  type="success"
                  showpick={false}
                  title=""
                  text={textData}
                />
              </div>

              <div className="row-custom" style={{ width: '100%' }}>
                <div className="col-12 col-md-6 col-lg-8">
                  <h2 style={{ marginTop: 0, marginBottom: '0.5rem' }}>Resultado da Pesquisa</h2>
                  <p className="little_text">Selecione os GTINs que gostaria de consultar os dados do produto</p>
                </div>
                <div style={{ marginTop: '15px', marginRight:'70px', width:'100%', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <div className="col-12 col-md-6 col-lg-4">
                    {view.content && (<ExportDetail dataPrepared={Datapagina} itemType={'VERIFY_NCM'} />)}
                  </div>
                  <button
                    type="submit"
                    className="custom-button-especial"
                    style={{fontSize:'14px', width:'27%'}}
                    disabled={isDisabled}
                    onClick={handleConsultarDadosProduto}
                  >
                    Consultar os dados do produto
                  </button>
                </div>
              </div>
            </div>

            <div className="container px-0 bg-color-white rounded-lg">
              <DataTable
                columns={columns}
                data={Datapagina}
                pagination
                responsive
                selectableRows
                selectableRowsHighlight
                noDataComponent="Sem registros para exibir"
                highlightOnHover
                onSelectedRowsChange={handleSelectedRowsChange}
                customStyles={customStyles}
                paginationComponent={BootyPagination}
              />
            </div>
          </div>
        </div>
       )} 
      <Modal
        isOpen={isModalOpen}
        contentLabel="Selected Option"
        style={{
          overlay: {
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "#262626CC",
            zIndex: 1000,
          },
          content: {
            maxWidth: "485px",
            height: "270px",
            marginTop: "5%",
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            zIndex: 1000,
            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "20px",
            outline: "none",
            padding: "10px",
          },
        }}
      >
        <div style={{ padding: "0.5rem" }}>
          <span
            onClick={closeChangeScreenModal}
            style={{ position: "absolute", right: "7px", top: "7px", cursor: 'pointer' }}
            aria-label="Fechar modal"
            title="Fechar"
          >
            <IoMdClose />
          </span>

          <div style={{ display: "flex", flexDirection: "column", rowGap: "2rem" }}>
            <div style={{ color: "rgb(105, 109, 115)", marginBottom: "-15px" }}>
              <div className="section">
                <div className="custom-col12 col-md-12" style={{ display: "flex", fontSize: "17px" }}>
                  <div className="w-1/2 md:w-full table-responsive"
                       style={{ textAlign: "left", lineHeight: "1.3" }}>
                    <div className="custom-fontSize"
                         style={{
                           display: "flex",
                           flexDirection: "column",
                           justifyContent: "center",
                           alignItems: "center",
                           height: "180px",
                           textAlign: "justify",
                         }}>
                      <div style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "20px",
                      }}>
                        <span style={{ fontWeight: "bold", color:'#002C6C'}}>
                         Aviso de redirecionamento
                        </span>
                      </div>
                      <div className="flex" style={{ display: 'grid', gap: 8 }}>
                        <div>
                        Você será redirecionado para a aba de consulta múltipla e não poderá retornar à tela anterior. Ao clicar em <strong>Continuar</strong>, a consulta atual será baixada.
                        </div>
                      </div>
                    </div>

                    <div className="custom-display-buttons" style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button
                          style={{ maxWidth: "170px", marginRight: "10px" }}
                          className="btn btn-outline-primary custom-fontSize"
                          onClick={handleConfirmChangeScreen}
                        >
                          Cancelar
                        </button>
                      </div>

                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button
                          style={{ maxWidth: "170px" }}
                          className="btn btn-primary custom-fontSize"
                          onClick={handleContinuar}
                        >
                          Continuar
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </Modal>

      <Modal
        isOpen={isModalOpenBack}
        contentLabel="Selected Option"
        style={{
          overlay: {
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "#262626CC",
            zIndex: 1000,
          },
          content: {
            maxWidth: "485px",
            height: "270px",
            marginTop: "5%",
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            zIndex: 1000,
            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "20px",
            outline: "none",
            padding: "10px",
          },
        }}
      >
        <div style={{ padding: "0.5rem" }}>
          <span
            onClick={closeChangeScreenModalBack}
            style={{ position: "absolute", right: "7px", top: "7px", cursor: 'pointer' }}
            aria-label="Fechar modal"
            title="Fechar"
          >
            <IoMdClose />
          </span>

          <div style={{ display: "flex", flexDirection: "column", rowGap: "2rem" }}>
            <div style={{ color: "rgb(105, 109, 115)", marginBottom: "-15px" }}>
              <div className="section">
                <div className="custom-col12 col-md-12" style={{ display: "flex", fontSize: "17px" }}>
                  <div className="w-1/2 md:w-full table-responsive"
                       style={{ textAlign: "left", lineHeight: "1.3" }}>
                    <div className="custom-fontSize"
                         style={{
                           display: "flex",
                           flexDirection: "column",
                           justifyContent: "center",
                           alignItems: "center",
                           height: "180px",
                           textAlign: "justify",
                         }}>
                      <div style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "20px",
                      }}>
                        <span style={{ fontWeight: "bold", color:'#002C6C'}}>
                         Atenção!
                        </span>
                      </div>
                      <div className="flex" style={{ display: 'grid', gap: 8 }}>
                        <div>
                          Ao voltar para a lista de GTINs, o download da lista que você acabou de consultar será iniciado automaticamente.
                        </div>
                      </div>
                    </div>

                    <div className="custom-display-buttons" style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button
                          style={{ maxWidth: "170px", marginRight: "10px" }}
                          className="btn btn-outline-primary custom-fontSize"
                          onClick={()=>{setIsModalOpenBack(false)}}
                        >
                          Cancelar
                        </button>
                      </div>

                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button
                          style={{ maxWidth: "170px" }}
                          className="btn btn-primary custom-fontSize"
                          onClick={handleContinuarBackList}
                        >
                          Continuar
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </Modal>

      <Modal
        isOpen={isModalOpen}
        contentLabel="Selected Option"
        style={{
          overlay: {
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "#262626CC",
            zIndex: 1000,
          },
          content: {
            maxWidth: "485px",
            height: "270px",
            marginTop: "5%",
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            zIndex: 1000,
            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "20px",
            outline: "none",
            padding: "10px",
          },
        }}
      >
        <div style={{ padding: "0.5rem" }}>
          <span
            onClick={closeChangeScreenModal}
            style={{ position: "absolute", right: "7px", top: "7px", cursor: 'pointer' }}
            aria-label="Fechar modal"
            title="Fechar"
          >
            <IoMdClose />
          </span>

          <div style={{ display: "flex", flexDirection: "column", rowGap: "2rem" }}>
            <div style={{ color: "rgb(105, 109, 115)", marginBottom: "-15px" }}>
              <div className="section">
                <div className="custom-col12 col-md-12" style={{ display: "flex", fontSize: "17px" }}>
                  <div className="w-1/2 md:w-full table-responsive"
                       style={{ textAlign: "left", lineHeight: "1.3" }}>
                    <div className="custom-fontSize"
                         style={{
                           display: "flex",
                           flexDirection: "column",
                           justifyContent: "center",
                           alignItems: "center",
                           height: "180px",
                           textAlign: "justify",
                         }}>
                      <div style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "20px",
                      }}>
                        <span style={{ fontWeight: "bold", color:'#002C6C'}}>
                         Aviso de redirecionamento
                        </span>
                      </div>
                      <div className="flex" style={{ display: 'grid', gap: 8 }}>
                        <div>
                        Você será redirecionado para a aba de consulta múltipla e não poderá retornar à tela anterior. Ao clicar em <strong>Continuar</strong>, a consulta atual será baixada.
                        </div>
                      </div>
                    </div>

                    <div className="custom-display-buttons" style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button
                          style={{ maxWidth: "170px", marginRight: "10px" }}
                          className="btn btn-outline-primary custom-fontSize"
                          onClick={handleConfirmChangeScreen}
                        >
                          Cancelar
                        </button>
                      </div>

                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button
                          style={{ maxWidth: "170px" }}
                          className="btn btn-primary custom-fontSize"
                          onClick={handleContinuar}
                        >
                          Continuar
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </Modal>
      
      <Modal
        isOpen={ipsOpenModalConfirm}
        contentLabel="Selected Option"
        style={{
          overlay: {
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "#262626CC",
            zIndex: 1000,
          },
          content: {
            maxWidth: "485px",
            height: "270px",
            marginTop: "5%",
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            zIndex: 1000,
            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "20px",
            outline: "none",
            padding: "10px",
          },
        }}
      >
        <div style={{ padding: "0.5rem" }}>
          <span
            onClick={closeChangeScreenModalConfirm}
            style={{ position: "absolute", right: "7px", top: "7px", cursor: 'pointer' }}
            aria-label="Fechar modal"
            title="Fechar"
          >
            <IoMdClose />
          </span>

          <div style={{ display: "flex", flexDirection: "column", rowGap: "2rem" }}>
            <div style={{ color: "rgb(105, 109, 115)", marginBottom: "-15px" }}>
              <div className="section">
                <div className="custom-col12 col-md-12" style={{ display: "flex", fontSize: "17px" }}>
                  <div className="w-1/2 md:w-full table-responsive"
                       style={{ textAlign: "left", lineHeight: "1.3" }}>
                    <div className="custom-fontSize"
                         style={{
                           display: "flex",
                           flexDirection: "column",
                           justifyContent: "center",
                           alignItems: "center",
                           height: "180px",
                           textAlign: "justify",
                         }}>
                      <div style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "20px",
                      }}>
                        <span style={{ fontWeight: "bold", color:'#002C6C'}}>
                         Atenção!
                        </span>
                      </div>
                      <div className="flex" style={{ display: 'grid', gap: 8 }}>
                        <div>
                          Identificamos que a quantidade de códigos disponível na página selecionada é superior ao limite disponível da empresa. Ao clicar em "Continuar", a consulta será realizada, mas <strong>será entregue apenas a quantidade disponível do limite da sua empresa.</strong>
                        </div>
                      </div>
                    </div>

                    <div className="custom-display-buttons" style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop:10}}>
                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button
                          style={{ maxWidth: "170px", marginRight: "10px" }}
                          className="btn btn-outline-primary custom-fontSize"
                          onClick={()=>{setIpsOpenModalConfirm(false)}}
                        >
                          Cancelar
                        </button>
                      </div>

                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button
                          style={{ maxWidth: "170px" }}
                          className="btn btn-primary custom-fontSize"
                          onClick={handleConfirmarConsulta}
                        >
                          Continuar
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </Modal>
    </>
  );
};

export default SearchOneNCM;
